import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-hard-redirect',
  templateUrl: './hard-redirect.component.html',
  styles: [
  ]
})
export class HardRedirectComponent implements OnInit {

  constructor(private dialogRef: MatDialogRef<HardRedirectComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {

  }
  ngOnInit(): void {

  }

  confirm() {
    this.dialogRef.close(true);
  }
}
